export const toastrOptions = {
  showCloseButton: false,
};
